import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var OpenInNewTabButtonContainer = styled.div({
  margin: "0 ".concat("var(--ds-space-075, 6px)"),
  visibility: 'hidden'
});